import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  MenuItem,
  Modal,
  Select,
  Typography,
} from "@material-ui/core";
import { ArrowUpRight, Eye, EyeSlash, FilmSlate } from "phosphor-react";
import React, { useEffect, useRef, useState } from "react";
import * as Icon from "react-feather";
import { useLocation } from "react-router-dom";
import { fget } from "../../../API/callsAPI";
import CanvasFrame from "../../CanvasFrame/CanvasFrame.component";
import Player from "../../Player/player.component";
import StatusDropDown from "../../Utilities/StatusDropDown/StatusDropDown.component";
import ThreeDModelSvg from "../../Utilities/Svg/ThreeDModelSvg";
import { checkGlb, checkImage } from "../../utils";
import UpdatesPageCardComment from "../UpdatesPageCardsTools/UpdatesPageCardComment.component";
import UpdatesPageCardCommentDiv from "../UpdatesPageCardsTools/UpdatesPageCardCommentDiv.component";
import UpdateLoaderSvg from "./UpdateLoaderSvg";
import useStyles from "./UpdatesPageUpdateCards.styles";

function UpdatesPageUpdateCards(props) {
  const classes = useStyles();
  //States

  const [updateDetail] = useState(props.update);
  const [showComments, setShowComments] = useState(false);
  const [commentCount, setCommentCount] = useState(
    props.update.comments ? props.update.comments.count : 0
  );
  const [commentList, setCommentList] = useState(
    props.update.comments ? props.update.comments.results : null
  );
  const [seekTime, setSeekTime] = useState(0);
  const [screenshot, setScreenshot] = useState(null);
  const [displayImage, setDisplayImage] = useState(null);
  const [imageModal, setImageModal] = useState(false);
  const [imageRef, setImageRef] = useState(null);
  const [canvasModal, setCanvasModal] = useState(false);
  const [playerProgress, setPlayerProgress] = useState("00:00");
  const [repliedTo, setRepliedTo] = useState({});
  const player = useRef(null);
  const location = useLocation();

  const canvasModalToggle = () => {
    setCanvasModal(!canvasModal);
  };
  const displayImageToggle = () => setImageModal(!imageModal);

  const values = [
    { id: 1, name: "Newest" },
    { id: 2, name: "Oldest" },
    { id: 3, name: "Incomplete " },
    { id: 4, name: "Time code" },
  ];

  const handleOpenVersionInNewTab = () => {
    //logic is totally flawed when it comes to other trackables

    //TODO: flawed logic, improve this and handle all edge cases

    if (props?.update?.resource_class === "assetversion") {
      location.pathname = `/${props.projectId}/assets/${props?.update?.resource_object.asset?.id}/assetversions`;
      const encode = btoa(
        unescape(encodeURIComponent(`versionId=${props?.update?.resource_id}`))
      );

      window.open(`${location.pathname}?${encode}`);
    } else if (props?.update?.resource_class === "shotversion") {
      location.pathname = `/${props.projectId}/sequence/${props?.update?.resource_object?.shot?.parent_sequence}/shots/${props?.update?.resource_object?.shot?.id}/shotversions/`;
      const encode = btoa(
        unescape(
          encodeURIComponent(`versionId=${props?.update?.resource_object?.id}`)
        )
      );

      window.open(`${location.pathname}?${encode}`);
    }
  };

  const fetchComments = async () => {
    try {
      const commentsRes = await fget({
        url: `trackables/trackable-comment/?version_id=${updateDetail.resource_object.id}&&version_type=${updateDetail.resource_class}`,
      });
      if (commentsRes.status === 200 || 201) {
        setCommentList(commentsRes.data.results);
        setCommentCount(commentsRes.data.count);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const changeSeekTime = (time) => {
    time = time.trim();
    if (time.includes(":")) {
      var timeInNos = 0; //setting time to 0
      if (time.length === 4) {
        timeInNos +=
          parseInt(time.substr(0, 1)) * 60 + parseInt(time.substr(2, 2));
      } else {
        timeInNos +=
          parseInt(time.substr(0, 2)) * 60 + parseInt(time.substr(3, 2));
      }
      setSeekTime(timeInNos);
    } else {
      setSeekTime(time);
    }
  };

  return (
    <>
      <Modal
        open={imageModal}
        onClose={displayImageToggle}
        className={classes.modal1}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            outline: "none",
            height: "80vh",
          }}
        >
          <Icon.X
            style={{ alignSelf: "flex-end" }}
            onClick={displayImageToggle}
          />
          <img
            src={displayImage}
            height="90%"
            alt="attachment"
            onContextMenu={(e) => e.preventDefault()}
          ></img>
        </div>
      </Modal>
      <div>
        <Modal open={canvasModal} className={classes.modal1}>
          <CanvasFrame
            users={props.users}
            imageRef={imageRef}
            image={screenshot}
            progress={playerProgress}
            //flawed logic needs to be fixed!
            assetID={
              updateDetail.resource_object
                ? updateDetail.resource_object.asset
                  ? updateDetail.resource_object.asset?.id
                  : updateDetail.resource_object.shot?.id
                : null
            }
            closeModal={canvasModalToggle}
            toggle={canvasModalToggle}
            version_id={
              updateDetail.resource_object
                ? updateDetail.resource_object.id
                : null
            }
            fetchComments={fetchComments}
          />
        </Modal>
      </div>
      <div style={{ marginBottom: "15px" }}>
        <Card className={classes.cardDiv}>
          <CardContent className={classes.cardContent}>
            <div className={classes.flexBetween}>
              <div className={classes.updateTile}>
                <Box className={classes.trackableIcon}>
                  <FilmSlate size={22} fill="#6C65D9" type="filled" />
                </Box>
                <div
                  className={classes.title}
                  onClick={() => handleOpenVersionInNewTab()}
                >
                  {/* {updateDetail.message} */}
                  {/* {updateDetail.resource_object
                    ? updateDetail.resource_object.name
                    : null} */}
                  {updateDetail?.resource_object?.created_by?.first_name} added
                  a version
                </div>
              </div>
              <div className={classes.date}>
                {new Intl.DateTimeFormat("en-IN", {
                  day: "2-digit",
                  month: "long",
                  year: "numeric",
                }).format(new Date(updateDetail.created_at))}
              </div>
            </div>
            <div className={classes.flexBetween}>
              <Typography className={classes.object_name}>
                {props.update?.resource_object?.name}
              </Typography>
              <div className={classes.status}>
                <StatusDropDown
                  url={`trackables/${
                    props.update.resource_class === "asset"
                      ? "asset"
                      : props.update.resource_class === "assetversion"
                      ? "asset-version"
                      : props.update.resource_class === "sequence"
                      ? "shot-sequence"
                      : props.update.resource_class === "shot"
                      ? "shot"
                      : "shot-version"
                  }/${props.update.resource_object?.id}/`}
                  statusList={props?.statusList}
                  currStatus={updateDetail?.resource_object?.status}
                  updateRefreshCounter={props.updateRefreshCounter}
                />
                {/* <StatusViewer status={updateDetail?.resource_object?.status} /> */}
              </div>
            </div>
            <div className={classes.contentInfoWithUser}>
              <div className={classes.cardMediaContainer}>
                <div>
                  {updateDetail.signed_url ? (
                    checkImage(updateDetail.resource_object.file) ? (
                      <>
                        <img
                          ref={(image) => {
                            setImageRef(image);
                          }}
                          crossOrigin="Anonymous"
                          onClick={() => {
                            setDisplayImage(updateDetail.signed_url.signed_url);
                            displayImageToggle();
                          }}
                          // className="card-img-top"
                          src={updateDetail.signed_url.signed_url}
                          alt="Project new"
                          className={classes.image}
                          onContextMenu={(e) => e.preventDefault()}
                        ></img>
                      </>
                    ) : checkGlb(updateDetail.signed_url?.signed_url) ? (
                      updateDetail.signed_url?.signed_url ? (
                        <>
                          <div className={classes.flexCenter}>
                            <ThreeDModelSvg />
                          </div>
                          {/* <div style={{ height: "250", position: "relative" }}>
                          <img
                            src={threeDImage}
                            alt=""
                            className={classes.threeDImage}
                          />
                          <div className={classes.threeIconContainer}>
                            <div
                              style={{
                                display: isHovered ? "flex" : "none",
                              }}
                              className={classes.noteModal}
                            >
                              <div>
                                <ThreeDIcon />
                              </div>
                              <div>
                                This is a 3D asset, to “view” please click on
                                “open in version viewer”
                              </div>
                            </div>
                            <Button
                              onMouseEnter={() => setIsHovered(true)}
                              onMouseLeave={() => setIsHovered(false)}
                            >
                              <ThreeDIcon />
                            </Button>
                          </div>
                        </div> */}
                        </>
                      ) : (
                        "File is Loading"
                      )
                    ) : (
                      <>
                        <Player
                          users={props.users}
                          className="card-img-top"
                          controls
                          alt="Project new"
                          autoPlay
                          muted
                          width="100%"
                          height="100%"
                          data={updateDetail.signed_url.signed_url}
                          seekTime={seekTime}
                          setSeekTime={setSeekTime}
                          screenshot={screenshot}
                          setScreenshot={setScreenshot}
                          assetId={
                            updateDetail.resource_object.asset
                              ? updateDetail.resource_object.asset?.id
                              : updateDetail.resource_object.shot?.id
                          }
                          version_id={updateDetail.resource_object.id}
                          setList={setCommentList}
                          updatesPage={true}
                          setPlayerProgress={setPlayerProgress}
                          canvasModal={canvasModal}
                          player={player}
                        />
                      </>
                    )
                  ) : (
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <UpdateLoaderSvg />
                    </Box>
                  )}
                </div>
              </div>
            </div>
            <div className={classes.commentAndAnnotation}>
              <div>
                {updateDetail.comments ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      // marginTop: "13px",
                    }}
                  >
                    <UpdatesPageCardComment
                      users={props.users}
                      //flawed logic as it misses out other trackables
                      trackableId={
                        updateDetail.resource_object.shot
                          ? updateDetail.resource_object?.shot?.id
                          : updateDetail.resource_object?.asset?.id
                      }
                      versionId={updateDetail.resource_object.id}
                      setCommentList={setCommentList}
                      updateCommentCount={() =>
                        setCommentCount(commentCount + 1)
                      }
                      repliedTo={repliedTo}
                      setRepliedTo={setRepliedTo}
                      fetchComments={fetchComments}
                    />
                    <Button
                      className={classes.editButton}
                      onClick={canvasModalToggle}
                    >
                      <Icon.Edit className={classes.editLogo} />
                    </Button>
                  </div>
                ) : null}
              </div>
              <div style={{ marginTop: "10px" }}>
                {updateDetail?.comments ? (
                  <div className={classes.flexBetween}>
                    <div
                      onClick={(e) => {
                        setShowComments(!showComments);
                      }}
                      className={classes.commentIconDiv}
                    >
                      <span className={classes.showHide}>
                        {showComments ? (
                          <span className={classes.showHide}>
                            <EyeSlash size={18} /> <span>Hide all </span>
                          </span>
                        ) : (
                          <span className={classes.showHide}>
                            <Eye size={18} /> <span>Show all</span>
                          </span>
                        )}
                        {commentCount} Comments
                      </span>
                    </div>

                    <div
                      onClick={() => handleOpenVersionInNewTab()}
                      className={classes.commentIconDiv}
                    >
                      <span className={classes.showHide}>
                        <span className={classes.showHide}>
                          <span>Open in version viewer </span>
                          <ArrowUpRight size={18} />
                        </span>
                      </span>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              {showComments ? (
                <div className={classes.commentsTools}>
                  <div className={classes.statusDropDown}>
                    <FormControl fullWidth>
                      <Select
                        disableUnderline
                        className={classes.input}
                        value={values[0].id || "none"}
                        // onClick={(e) => e.stopPropagation()}
                        // onChange={handleStatusChange}
                      >
                        {values.map((status) => (
                          <MenuItem
                            className={classes.menuItem}
                            value={status.id}
                            key={status.id}
                          >
                            <div className={classes.filterText}>
                              <span
                                style={{ width: "100%", overflow: "hidden" }}
                              >
                                {status.name}
                              </span>
                            </div>
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className={classes.grayText}>
                    {commentList.length} comments
                  </div>
                </div>
              ) : (
                ""
              )}
              <div>
                {showComments ? (
                  updateDetail.comments ? (
                    <UpdatesPageCardCommentDiv
                      commentResult={commentList}
                      setCommentList={setCommentList}
                      commentList={commentList}
                      updateDetail={updateDetail}
                      updateCommentCount={(e) => setCommentCount(e)}
                      changeSeekTime={changeSeekTime}
                      setRepliedTo={setRepliedTo}
                    />
                  ) : null
                ) : null}
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
}

export default UpdatesPageUpdateCards;
